export default __webpack_public_path__ + "static/media/video.9a5800cd.png";